export { default as Three } from "./3D"
export { default as Image } from "./Image"
export { default as Map } from "./Map"
export { default as Details } from "./Details"
export { default as Summary } from "./Summary"
export { default as Link } from "./Link"
export { default as Quiz } from "./Quiz"
